export const environment = {
  production: true,
  apiUrl:'https://api.checkin.uncan.ax/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts